<template>

    <tbody>
        <tr v-for="x in rows">
            <td v-for="x in cols">
                <div class="linear-background"></div>
            </td>
        </tr>
    </tbody>

</template>

<script>
export default {
  props: ['cols'],
  data () {
    return {
      rows: 5
    }
  }
}
</script>

<style scoped>
@keyframes placeHolderShimmer{
    0%{
        background-position: -468px 0
    }
    100%{
        background-position: 468px 0
    }
}
.linear-background {
    margin-top: 20px;
    margin-bottom: 20px;
    border-radius: 6px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background-size: 1000px 104px;
    height: 15px;
    position: relative;
    overflow: hidden;
}

</style>
